import { getAuthAdapter } from "~/resolvers/auth_resolver";
import type { AuthUser } from "~/core/domain/services/i-auth-adapter";

/**
 * 認証ヘッダーを取得する
 *
 * クライアントサイドで使用（clientLoader/clientActionで使用）
 * 認証プロバイダー（Supabase、Firebase等）に応じて適切な実装を呼び出す
 *
 * @returns 認証ヘッダーを含むHeadersInitオブジェクト
 */
export async function getAuthorizationHeaders(): Promise<HeadersInit> {
  const authAdapter = getAuthAdapter();
  const token = await authAdapter.getAccessToken();

  const headers: HeadersInit = {};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

/**
 * 認証されているユーザーを取得する
 *
 * クライアントサイドで使用（clientLoader/clientActionで使用）
 * 認証プロバイダー（Supabase、Firebase等）に応じて適切な実装を呼び出す
 *
 * @returns 認証されているユーザー（未認証の場合はnull）
 */
export async function getAuthUser(): Promise<AuthUser | null> {
  const authAdapter = getAuthAdapter();
  return await authAdapter.getUser();
}
